import { render, staticRenderFns } from "./DisposalOrdersCreation.vue?vue&type=template&id=139e3ec2&scoped=true"
import script from "./DisposalOrdersCreation.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139e3ec2",
  null
  
)

export default component.exports